import { Component, Input, OnInit } from '@angular/core';


import { Task } from './tasks/task';
import { TasksService } from './tasks/tasks.service';

@Component({
  selector: 'app-implementation-strategy',
  templateUrl: './implementation-strategy.component.html',
  styleUrls: ['./implementation-strategy.component.css']
})
export class ImplementationStrategyComponent implements OnInit {

  @Input() onShowPeriod;
  windowWith;
  tasks: Task [];
  mockTasks: Task [] = [];

  constructor(
    private _tasksService: TasksService) {}

  getTasks(): void {
    this._tasksService.getTasks().then(tasks => this.tasks = tasks);
  }

  getMockTasks(): void {
    this._tasksService.getMockTasks().then(mockTasks => this.mockTasks = mockTasks);
  }

  ngOnInit(): void {
    this.windowWith = window.innerWidth;
    this.getMockTasks();
    this.getTasks();
  }

  onResize(event) {
    this.windowWith = event.target.innerWidth;
  }

  breakRow(theArr: any[]) {
    const arrOfarr = [];
    if (this.windowWith > 768) {
      for (let i = 0; i < theArr.length ; i+=3) {
        const row = [];
        for (let x = 0; x < 3; x++) {
          const value = theArr[i + x];
          if (!value) {
            break;
          }
          row.push(value);
        }
        arrOfarr.push(row);
      }
      return arrOfarr;
    } else if (this.windowWith > 480) {
      for (let i = 0; i < theArr.length ; i+=2) {
        console.log(this.windowWith);
        const row = [];
        for (let x = 0; x < 2; x++) {
          const value = theArr[i + x];
          if (!value) {
            break;
          }
          row.push(value);
        }
        arrOfarr.push(row);
      }
      return arrOfarr;
    } else {
      for (let i = 0; i < theArr.length ; i+=1) {
        console.log(this.windowWith);
        const row = [];
        for (let x = 0; x < 1; x++) {
          const value = theArr[i + x];
          if (!value) {
            break;
          }
          row.push(value);
        }
        arrOfarr.push(row);
      }
      return arrOfarr;
    }
  }

}



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/keynote/components/next/components/implementation-strategy/implementation-strategy.component.ts